/**
 * VaultColorPicker: Preset color circle grid for folder icon customization
 */
import { Check } from 'lucide-react';
import { VAULT_FOLDER_COLORS } from '../../types/vault.types';

interface VaultColorPickerProps {
  selectedColor: string;
  onSelect: (hex: string) => void;
  size?: 'sm' | 'md';
}

export function VaultColorPicker({ selectedColor, onSelect, size = 'md' }: VaultColorPickerProps) {
  const circleSize = size === 'sm' ? 24 : 32;
  const checkSize = size === 'sm' ? 12 : 16;

  return (
    <div className="vault-color-picker">
      {VAULT_FOLDER_COLORS.map(({ hex, name }) => {
        const isActive = selectedColor === hex;
        return (
          <button
            key={hex}
            className={`vault-color-swatch ${isActive ? 'active' : ''}`}
            style={{
              backgroundColor: hex,
              width: circleSize,
              height: circleSize,
            }}
            onClick={() => onSelect(hex)}
            title={name}
            type="button"
            aria-label={`${name} color`}
          >
            {isActive && <Check size={checkSize} color="#fff" strokeWidth={3} />}
          </button>
        );
      })}
    </div>
  );
}
